import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'cstar-react-primitives/lib/redux-form/alert/Alert';

import { injectIntl, intlShape } from 'react-intl';
import PromoErrorModal from '../promoDisplay/PromoErrorModal';
import {
    paymentDeclined, limitReached, fieldError, promoExpired, promoLimited, mismatchAuthAmount, idMapper
} from './capiResponseMessages';

const generateMessageAndHeader = (fieldErrors, intl) => {
    let message = '';
    for (let i = 0; i < fieldErrors.length; i++) {
        if (idMapper[fieldErrors[i]]) {
            message = `${message}- ${intl.formatMessage(idMapper[fieldErrors[i]].message)}\n\n`;
        } else {
            return [paymentDeclined.heading, paymentDeclined.message];
        }
    }
    return [fieldError.heading, message];
};


const PaymentError = ({
    capiCode, fieldErrors, submit, isCreditCardPayment, intl
}) => {
    if (capiCode && capiCode.includes('PROMO')) {
        let promoErrorProps;
        let promoMessage;
        switch (capiCode) {
            case 'PROMO_EXPIRED':
                
                promoMessage = isCreditCardPayment ? promoExpired.message : promoExpired.messageAlt;
                promoErrorProps = {
                    errorHeading: promoExpired.heading,
                    errorMessage: promoMessage,
                    submit,
                    isCreditCardPayment
                };
                break;
            case 'PROMO_LIMITED':
                promoMessage = isCreditCardPayment ? promoLimited.message : promoLimited.messageAlt;
                promoErrorProps = {
                    errorHeading: promoLimited.heading,
                    errorMessage: promoMessage,
                    submit,
                    isCreditCardPayment
                };
                break;
            case 'MISMATCH_AUTH_PROMO_AMOUNT':
                
                promoMessage = isCreditCardPayment ? mismatchAuthAmount.message : mismatchAuthAmount.messageAlt;
                promoErrorProps = {
                    errorHeading: mismatchAuthAmount.heading,
                    errorMessage: promoMessage,
                    submit,
                    isCreditCardPayment
                };
                break;
            default:
                break;
        }
        return <PromoErrorModal {...promoErrorProps} />;
    }
    
    let errorHeading = paymentDeclined.heading;
    let errorMessage = paymentDeclined.message;

    if (fieldErrors.length) {
        [errorHeading, errorMessage] = generateMessageAndHeader(fieldErrors, intl);
    }

    if (capiCode === 'DAILY_LIMIT') {
        errorHeading = limitReached.heading;
        errorMessage = limitReached.message;
    }
    const alertProps = {
        alertType: 'error',
        message: errorMessage
    };

    if (errorHeading) {
        alertProps.heading = errorHeading;
    } else {
        alertProps.hasHeading = false;
    }
    return <Alert {...alertProps} />;
};


PaymentError.defaultProps = {
    capiCode: 'PAYMENT_DECLINED',
    fieldErrors: [],
    submit: () => {},
    isCreditCardPayment: false
};

PaymentError.propTypes = {
    intl: intlShape.isRequired,
    capiCode: PropTypes.string,
    fieldErrors: PropTypes.array,
    submit: PropTypes.func,
    isCreditCardPayment: PropTypes.bool
};

export default injectIntl(PaymentError);
